import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { DashboardIframe } from './DashboardIframe';
import Select from 'components/ui/SelectField';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import { authenticateInsightsDashboard, fetchInsightDashboards } from 'actions/insightsActions';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

const StyledSelect = styled(Select)`
  ${media.desktop`
    width: 80%;
    margin-top: 10px;
  `} flex: 1;
`;

const StyledMain = styled.main`
  background-color: #fafafc;
  margin-top: 53px;
  height: 100vh;
  overflow: scroll;
  ${media.mobile`
    margin-top: 0;
  `};
`;

export const StyledHeader = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex: 1;
  ${media.largeDesktop`
    margin-bottom: 0;
  `};
`;

export const StyledHeaderContainer = styled.div`
  padding: 20px 20px 9px;
  display: flex;
  flex-direction: row;
  ${media.mobile`
    justify-content: space-between;
    flex-direction: column;
    position: sticky !important;
    top: -82px;
    z-index: 1;
    background: #fafafc;
    padding-top: 70px;
    justify-content: space-between;
    flex-direction: column;
  `};
`;

const StyledCenterContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  ${media.mobile`
    margin-top: 75px;
  `} ${media.desktop`
    margin-top: 75px;
  `};
`;

const StyledImg = styled.img`
  width: 100%;
  padding: 1rem 5rem;
`;

const StyledMissingHeader = styled.h3`
  font-size: 1.5rem;
  font-family: 'Circular-Bold';
`;

const StyledMissingP = styled.p`
  ${media.desktop`
    padding: 0 5rem;
  `};
`;

class InsightDashboards extends Component {
  state = {
    selectedDashboard: undefined,
  };

  componentDidMount() {
    this.props.fetchInsightDashboards().then(() => {
      if (this.props.selectedDashboardId) {
        const selectedDashboard = this.props.insightDashboards.find(
          dashboard => dashboard.dashboard_id === this.props.selectedDashboardId
        );
        this.setState({
          selectedDashboard: selectedDashboard.id,
        });
      }
    });
  }

  handleDashboardChange = dashboard => {
    this.setState(
      {
        selectedDashboard: dashboard,
      },
      () => {
        this.authenticateDashboard(dashboard);
      }
    );
  };

  authenticateDashboard = dashboardId => {
    this.props.authenticateInsightsDashboard(dashboardId);
  };

  render() {
    const { insightKey, insightToken, selectedDashboardId, insightDashboards } = this.props;

    return (
      <StyledMain>
        <StyledHeaderContainer>
          <StyledHeader>
            <HeaderWithPeriod
              headerText={<span>{getTranslatedString('landlordPortal.insights.insights')}</span>}
              newStyle
            />
          </StyledHeader>
          <StyledSelect
            value={this.state.selectedDashboard}
            onChange={this.handleDashboardChange}
            placeholder={getTranslatedString('landlordPortal.insights.selectADashboard')}
            size="large"
          >
            {insightDashboards &&
              insightDashboards.map(source => (
                <Select.Option value={source.id} title={source.name}>
                  {source.name}
                </Select.Option>
              ))}
          </StyledSelect>
        </StyledHeaderContainer>
        {!selectedDashboardId ? (
          <StyledCenterContainer>
            <StyledImg
              src="/dashboard_insights.svg"
              alt={getTranslatedString('landlordPortal.insights.whatInsights')}
            />
            <StyledMissingHeader>
              {getTranslatedString('landlordPortal.insights.whatInsights')}
            </StyledMissingHeader>
            <StyledMissingP>
              {getTranslatedString('landlordPortal.insights.selectAnOption')}
            </StyledMissingP>
          </StyledCenterContainer>
        ) : (
          <DashboardIframe
            insightKey={insightKey}
            insightToken={insightToken}
            dashboardId={selectedDashboardId}
          />
        )}
      </StyledMain>
    );
  }
}

const mapStateToProps = state => ({
  authenticatingInsights: state.insights.authenticatingInsights,
  authenticatingInsightsError: state.insights.authenticatingInsightsError,
  insightToken: state.insights.insightToken,
  insightKey: state.insights.insightKey,
  selectedDashboardId: state.insights.selectedDashboardId,
  fetchingInsightDashboards: state.insights.fetchingInsightDashboards,
  insightDashboards: state.insights.insightDashboards,
  ...state,
});

export default connect(mapStateToProps, { authenticateInsightsDashboard, fetchInsightDashboards })(
  InsightDashboards
);
